import { Screen } from '~/screens/client-contracts/new';

export const CreateClientContractTermFormIndex: React.FC = () => <Screen />;
